/**
 * Darstellung von Events (Bedarfsplaner): Farbe, Icon und die Vorlagen (Icon + Farbe in einem Klick) im
 * Event-Editor. Die Event-Farbe wird überall als CSS-Variable `--evf` gesetzt; Verlauf, Tönung und Schatten
 * leitet das CSS daraus ab (color-mix), siehe .mevent-bar / .evgrp in dienstplan.css.
 */

const EVENT_STANDARD_FARBE = '#7a5af0';

const EVENT_ICONS = ['stars', 'heart-fill', 'cake2', 'briefcase-fill', 'music-note-beamed', 'trophy', 'calendar-event', 'balloon'];

// Vorlagen für häufige Anlässe — setzen Icon und Farbe gemeinsam.
const EVENT_VORLAGEN = [
	{ name: 'Veranstaltung', icon: 'stars', farbe: '#7a5af0' },
	{ name: 'Hochzeit', icon: 'heart-fill', farbe: '#c0485a' },
	{ name: 'Geburtstag', icon: 'cake2', farbe: '#b8791a' },
	{ name: 'Firmenfeier', icon: 'briefcase-fill', farbe: '#2a6fdb' },
	{ name: 'Konzert', icon: 'music-note-beamed', farbe: '#1f3a6b' },
	{ name: 'Sport', icon: 'trophy', farbe: '#1f8a5b' },
];

// Vorschlagsfarben neben dem freien Farbwähler.
const EVENT_FARB_VORSCHLAEGE = ['#7a5af0', '#c0485a', '#b8791a', '#2a6fdb', '#1f3a6b', '#1f8a5b'];

const HEX = /^#[0-9a-f]{6}$/i;

/** Gültige Hex-Farbe des Events oder die Standardfarbe (Altdaten ohne/mit ungültiger Farbe). */
function eventFarbe(ev) {
	return HEX.test(ev?.Farbe || '') ? ev.Farbe : EVENT_STANDARD_FARBE;
}

/** Lesbare Schriftfarbe auf der Event-Farbe: dunkel bei hellen Farben, sonst weiß. */
function textFarbeAuf(hex) {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);
	const helligkeit = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
	return helligkeit > 0.62 ? '#1f2d4d' : '#fff';
}

/** Setzt Event-Farbe (--evf) und passende Schriftfarbe auf ein Element mit Event-Hintergrund. */
function faerbeEventElement(el, ev) {
	const farbe = eventFarbe(ev);
	el.style.setProperty('--evf', farbe);
	el.style.color = textFarbeAuf(farbe);
}

export {
	EVENT_STANDARD_FARBE,
	EVENT_ICONS,
	EVENT_VORLAGEN,
	EVENT_FARB_VORSCHLAEGE,
	eventFarbe,
	textFarbeAuf,
	faerbeEventElement,
};
